import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e28bb81"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增优惠券")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("记录")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "指定商品信息", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "商品名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "价格"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "最高价"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "最低价")
], -1))
const _hoisted_38 = { style: {"display":"flex"} }
const _hoisted_39 = { class: "item" }
const _hoisted_40 = { class: "item" }
const _hoisted_41 = { class: "item" }
const _hoisted_42 = { class: "item" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "分类信息", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "item item2",
    style: {"width":"50%"}
  }, "ID"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "item item2",
    style: {"width":"50%"}
  }, "分类名称")
], -1))
const _hoisted_45 = {
  class: "item",
  style: {"width":"50%"}
}
const _hoisted_46 = {
  class: "item",
  style: {"width":"50%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "商家优惠券" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: $setup.addApply
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          name: "basic",
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "关键字" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.searches.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event)),
                  placeholder: "请输入关键字",
                  style: {"width":"200px"}
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  type: "primary",
                  onClick: $setup.onSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  onClick: $setup.onReset
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          scroll: { x:'max-content' },
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'get_num_type')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (record.get_num_type == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, "不限制领取次数"))
                    : _createCommentVNode("", true),
                  (record.get_num_type == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, "限制次数"))
                    : _createCommentVNode("", true),
                  (record.get_num_type == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "每天限制数量"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'type')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.type == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "商家圈"))
                    : _createCommentVNode("", true),
                  (record.type == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "平台券"))
                    : _createCommentVNode("", true),
                  (record.type == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, "商家好物圈"))
                    : _createCommentVNode("", true),
                  (record.type == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "平台好物圈"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (record.status == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "启用"))
                    : _createCommentVNode("", true),
                  (record.status == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "停用"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin-left":"10px"},
                    onClick: ($event: any) => ($setup.getRecord(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin-left":"10px"},
                    onClick: ($event: any) => ($setup.getDetail(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible2,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible2) = $event)),
      title: "优惠券领取记录",
      width: "60%",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.recordData,
          columns: $setup.columns2,
          bordered: "",
          pagination: $setup.pagination2,
          onChange: $setup.handleTableChange2,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'avatar')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  src: record.avatar,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible3,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible3) = $event)),
      title: "优惠券详情",
      width: "60%",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          title: "优惠券信息",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "优惠券名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "优惠金额" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.money), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "类型" }, {
              default: _withCtx(() => [
                (_ctx.detailData.type == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, "商家圈"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.type == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, "平台券"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.type == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "商家好物圈"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.type == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, "平台好物圈"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "开始发放时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.send_time_start), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "结束发放时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.send_time_end), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "发送总量类型" }, {
              default: _withCtx(() => [
                (_ctx.detailData.send_total_type == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, "不限制"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.send_total_type == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, "订单满足金额"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "订单满足金额" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.condition_money), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "用券时间类型" }, {
              default: _withCtx(() => [
                (_ctx.detailData.use_time_type == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, "固定时间"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.use_time_type == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, "领券当天起"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.use_time_type == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, "领券次日起"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "使用开始时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.use_time_start), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "使用结束时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.use_time_end), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "几天可用" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.use_time), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "领取类型" }, {
              default: _withCtx(() => [
                (_ctx.detailData.get_type == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, "直接领取"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.get_type == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, "商家赠送"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "领取次数类型" }, {
              default: _withCtx(() => [
                (_ctx.detailData.get_num_type == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, "不限制领取次数"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.get_num_type == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, "限制次数"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.get_num_type == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, "每天限制数量"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "领取限制次数" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.get_num), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "每天可领取" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.day_get_num), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "适用商品类型" }, {
              default: _withCtx(() => [
                (_ctx.detailData.use_goods_type == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, "全部商品"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.use_goods_type == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, "指定商品"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.use_goods_type == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, "指定商品不可用"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "状态" }, {
              default: _withCtx(() => [
                (_ctx.detailData.status == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, "上架中"))
                  : _createCommentVNode("", true),
                (_ctx.detailData.status == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, "已下架"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_36,
        _hoisted_37,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.goods_coupon, (item, idnex) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_40, _toDisplayString(item.price), 1),
            _createElementVNode("div", _hoisted_41, _toDisplayString(item.max_price), 1),
            _createElementVNode("div", _hoisted_42, _toDisplayString(item.min_price), 1)
          ]))
        }), 256)),
        _hoisted_43,
        _hoisted_44,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.categorys, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            style: {"display":"flex"}
          }, [
            _createElementVNode("div", _hoisted_45, _toDisplayString(item.id), 1),
            _createElementVNode("div", _hoisted_46, _toDisplayString(item.name), 1)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}